import actionTypes from "../actionTypes";

export const setTenantNameAction = (data) => ({
  type: actionTypes.commonTypes.SET_TENANT_NAME,
  payload: data,
});

export const toggleSidebarAction = (data) => ({
  type: actionTypes.commonTypes.SIDEBAR_TOGGLE,
  payload: data,
});

export const setSelectedLanguageAction = (data) => ({
  type: actionTypes.commonTypes.SET_LANGUAGE,
  payload: data,
});

export const setPageLoaderAction = (data) => ({
  type: actionTypes.commonTypes.SET_PAGE_LOADER,
  payload: data,
});

export const getMyProfileAction = (data) => ({
  type: actionTypes.commonTypes.GET_MY_PROFILE,
  payload: data,
});

export const updateMyProfileAction = (data) => ({
  type: actionTypes.commonTypes.UPDATE_MY_PROFILE,
  payload: data,
});

export const resetPasswordAction = (data) => ({
  type: actionTypes.commonTypes.RESET_PASSWORD,
  payload: data,
});

export const contactUsAction = (data) => ({
  type: actionTypes.commonTypes.POST_CONTACT_US_NEW_COMPLAINT,
  payload: data,
});

export const setThemeStylesAction = (data) => ({
  type: actionTypes.commonTypes.SET_THEME_STYLES,
  payload: data,
});

export const setRoleUserMenuAction = (data) => ({
  type: actionTypes.commonTypes.SET_USER_ROLE_MENU,
  payload: data,
});

export const setTenantPermissionsInfoAction = (data) => ({
  type: actionTypes.commonTypes.GET_TENANT_PERMISSION_INFO,
  payload: data,
});
